define('GameDayCore/GDModel/enums/datasources/StorageKeys',{
    URL: "StorageKeys.URL",
    DATASOURCE_NAME: "StorageKeys.DATASOURCE_NAME"
});

